export default "__VITE_ASSET__0a202cf1__"